import React, { useState, useEffect } from 'react';
import { useSupabase } from '../../../contexts/SupabaseContext';
import { useNavigate } from 'react-router-dom';
import ProjectCard from './ProjectCard';
import { Card, CardContent } from '../../ui/card';
import { Input } from '../../ui/input';
import { Button } from '../../ui/button';
import { CalendarPlus } from 'lucide-react';
import { cn } from '../../../lib/utils';

const Projects = () => {
  const { projects, tasks, loadProjects, loadTasks, createProject } = useSupabase();

  const [isCreating, setIsCreating] = useState(false);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [dueDate, setDueDate] = useState('');

  const navigate = useNavigate();

  useEffect(() => {
    loadProjects();
    loadTasks();
  }, [loadTasks]);

  const submit = async () => {
    if (!title.trim()) return;
    try {
      await createProject({
        title,
        description,
        due_date: dueDate || null,
        status: 'todo',
      });
      setTitle('');
      setDescription('');
      setDueDate('');
      setIsCreating(false);
    } catch (err) {
      console.error('Failed to create project', err);
      alert(`Failed to create project: ${err?.message || err}`);
    }
  };

  return (
    <section className="projects">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold">Projects</h2>
        <Button size="sm" onClick={() => setIsCreating(true)} className="gap-1">
          <CalendarPlus className="w-4 h-4" /> New Project
        </Button>
      </div>

      {isCreating && (
        <Card className={cn('mb-6')}>
          <CardContent className="p-4 flex flex-col gap-3">
            <Input placeholder="Project title" value={title} onChange={e=>setTitle(e.target.value)} />
            <textarea className="border rounded-md p-2 text-sm" placeholder="Description" value={description} onChange={e=>setDescription(e.target.value)} />
            <Input type="date" value={dueDate} onChange={e=>setDueDate(e.target.value)} />
            <div className="flex gap-2">
              <Button size="sm" onClick={submit} disabled={!title.trim()}>Create</Button>
              <Button variant="ghost" size="sm" onClick={()=>setIsCreating(false)}>Cancel</Button>
            </div>
          </CardContent>
        </Card>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 overflow-y-auto">
        {projects.map((project:any) => {
          const subtasks = tasks.filter(t=>t.project_id === project.id);
          const completed = subtasks.filter(st=>st.status === 'completed').length;
          const percent = subtasks.length ? Math.round((completed/subtasks.length)*100) : 0;
          return (
            <ProjectCard key={project.id} project={project} percentComplete={percent} onClick={()=>navigate(`/projects/${project.id}`)} />
          );
        })}
      </div>
    </section>
  );
};

export default Projects; 